/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { RoutePath } from 'shared/enums/RoutePath';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import {
  selectDialog,
  selectInvitation,
  updateInvitation,
  selectStatus,
  toggleDialog,
  selectInvitationStatus,
} from './user.handleInvitation.slice';
import { acceptInvitation, declineInvitation } from './user.handleInvitation.thunk';
import { getUserThunk } from '../userAccounts/userAccounts.thunk';
import { notificationType } from '../../../../shared/enums/NotificationType';
import { invitationStatuses } from '../../../../shared/enums/invitationStatus';
import { handleRedirectAndReload } from '../../../../shared/utils/routingUtils';

export default function useHandleInvitation(userId) {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const status = useSelector(selectStatus);
  const dialog = useSelector(selectDialog);
  const invitation = useSelector(selectInvitation);
  const invitationStatus = useSelector(selectInvitationStatus);

  const onToggleDialog = open => dispatch(toggleDialog(open));
  const onUpdateInvitation = newInvitation => dispatch(updateInvitation(newInvitation));

  useEffect(() => {
    if (status === ThunkStatus.SUCCEEDED) {
      dispatch(getUserThunk(userId));
    }

    setIsLoading(status === ThunkStatus.LOADING);
  }, [status]);

  const onAcceptInvitation = (acceptedInvitation) => {
    onUpdateInvitation(acceptedInvitation);
    dispatch(toggleDialog(true));
  };

  const onAcceptedInvitationConfirm = () => {
    dispatch(toggleDialog(false));
    if (invitationStatus === invitationStatuses.ACCEPTED && invitation.type === notificationType.JOIN_ORGANIZATION)
      handleRedirectAndReload(RoutePath.SWITCH_ACCOUNT);
    if (invitationStatus === invitationStatuses.ACCEPTED && invitation.type === notificationType.MERGE_USER_ACCOUNT)
      handleRedirectAndReload(RoutePath.DASHBOARD);
  };

  const onSubmit = (invitationId) => {
    dispatch(acceptInvitation({ invitationId }));
  };

  const onDeclineInvitation = (invitationId) => {
    dispatch(declineInvitation({ invitationId }));
  };

  return {
    isLoading,
    dialog,
    invitation,
    invitationStatus,
    onSubmit,
    onUpdateInvitation,
    onAcceptInvitation,
    onDeclineInvitation,
    onAcceptedInvitationConfirm,
    onToggleDialog,
  };
}
